import { useEffect, useState } from 'react'

/**
 * Custom hook to replace Chakra UI's useMediaQuery
 * @param query - Media query string (e.g., '(min-width: 768px)')
 * @returns boolean indicating if the media query matches
 */
export function useMediaQuery(query: string): boolean {
    const [matches, setMatches] = useState(() => {
        if (typeof window !== 'undefined') {
            return window.matchMedia(query).matches
        }
        return false
    })

    useEffect(() => {
        const media = window.matchMedia(query)

        // Set initial value
        setMatches(media.matches)

        // Create listener
        const listener = (event: MediaQueryListEvent) => {
            setMatches(event.matches)
        }

        // Add listener (using addEventListener for better browser support)
        if (media.addEventListener) {
            media.addEventListener('change', listener)
        } else {
            // Fallback for older browsers
            media.addListener(listener)
        }

        // Cleanup
        return () => {
            if (media.removeEventListener) {
                media.removeEventListener('change', listener)
            } else {
                // Fallback for older browsers
                media.removeListener(listener)
            }
        }
    }, [query])

    return matches
}

